import {
  DEFAULT_LOCALE,
  LOCALES,
  localizedHref,
  type CollectionLabel,
  type Locale,
} from '@bailafm/shared';

const WEB_URL = import.meta.env.VITE_WEB_URL ?? 'http://localhost:3000';

/** Elige el mejor locale para la URL pública. ES con fallback al primer
 *  idioma con título (el label garantiza ≥1 por schema). Sin cascada en
 *  la web pública: enlazar a un locale sin título 404earía. */
export function pickCollectionLocale(label: CollectionLabel): Locale | null {
  if (typeof label[DEFAULT_LOCALE] === 'string' && label[DEFAULT_LOCALE]!.length > 0) {
    return DEFAULT_LOCALE;
  }
  return LOCALES.find((l) => typeof label[l] === 'string' && label[l]!.length > 0) ?? null;
}

/** Construye la URL pública absoluta de una colección.
 *  `null` si el label está vacío (no debería pasar por schema). */
export function collectionPublicUrl(
  slug: string,
  label: CollectionLabel,
): string | null {
  const locale = pickCollectionLocale(label);
  if (!locale) return null;
  return collectionUrlForLocale(slug, locale);
}

/** URL pública absoluta para un locale concreto. No comprueba si
 *  el label tiene título en ese idioma (responsabilidad del caller). */
export function collectionUrlForLocale(slug: string, locale: Locale): string {
  return `${WEB_URL}${localizedHref('collection', locale, { param: slug })}`;
}

/** Locales disponibles para una colección (aquellos con título). */
export function collectionAvailableLocales(
  label: CollectionLabel,
): Locale[] {
  return LOCALES.filter(
    (l) => typeof label[l] === 'string' && label[l]!.length > 0,
  );
}

export const LOCALE_LABELS: Record<Locale, string> = {
  es: 'Español',
  ca: 'Català',
  en: 'English',
};
